<div>
  <div class="breadcrumb">
    <!-- <div class="breadcrumb-heading">BreadCrumb:</div> -->
    <div class="breadcrumb-category">Сервіси /</div>
    <div>
      <ul>
        <li>
          {{ this.service?.category?.nameUa }}
        </li>
        <li>
          {{ this.service?.nameUa }}
        </li>
      </ul>
    </div>
  </div>
</div>

<p>{{ this.step + 1 }}/{{ this.stepsCount }}</p>

<div class="text-end">
  <dx-button
    text="{{ 'PROBLEM_SOLVED' | translate }}"
    (onClick)="this.goRatePage()"
    class="btn btn-secondary"
    icon="mdi mdi-check"></dx-button>
  @if (this.step + 1 == this.stepsCount) {
    <dx-button
      text="{{ 'CREATE_ORDER' | translate }}"
      (onClick)="this.createOrder()"
      class="btn ms-2"
      icon="mdi mdi-folder-plus"></dx-button>
  }
  <dx-button
    text="{{ 'PREV' | translate }}"
    [disabled]="this.step == 0"
    (onClick)="this.prevStep()"
    class="btn ms-2"
    icon="mdi mdi-chevron-left"></dx-button>
  <dx-button
    text="{{ 'NEXT' | translate }}"
    [disabled]="this.step + 1 == this.stepsCount"
    (onClick)="this.nextStep()"
    class="btn ms-2"
    icon="mdi mdi-chevron-right"></dx-button>
</div>

<fieldset class="fieldset mb-3">
  <legend>Библиотека знаний</legend>
  @if (this.selfDiagnosis) {
    <div [innerHTML]="this.selfDiagnosis.selfDiagnosisSteps[this.step].bodyUa" class="self-diagnostic-step-content"></div>
  }
</fieldset>
